import { FC } from 'react';
import { Rate } from '@base/lib/Rate';

export type IReviewsAverageProps = {
    className?: string;
    score: number | string;
    rateSize?: number | false;
}

export const ReviewsAverage: FC<IReviewsAverageProps> = (props) => {
    const { className, score, rateSize = false } = props

    return (
        <div className={className}>
            <div className={'g-score'}>{score}</div>
            <Rate className={'g-rate'} value={score} starSize={rateSize}/>
        </div>
    )
}